import { AfterViewInit, Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { APIService } from 'src/app/api.service';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';


export interface EmployeeList {
  orderno: number;
  item: string;
  supplier: string;
  rate: number;
  ordqty: number;
  amount: number;
  inwqty: number;
  unit: number;
  orddate: string;
  duedate: string;
  inwdate: string;
  invdate: string;
  grnno: number;
  rating: number;
  punctuality: number
}

export interface category {
  cid: number;
  cnm: string;
  sub: any[];
}

export interface subCategory {
  sid: number;
  snm: string;
}

const ELEMENT_DATA: EmployeeList[] = [
  {
    orderno: 1, item: 'Water', supplier: 'Ac Company', rate: 151,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Mar-19',
    duedate: '9-Feb-19', inwdate: '9-June-19', invdate: '9-Apr-19',
    grnno: 4, rating: 4, punctuality: 35
  },
  {
    orderno: 2, item: 'AC', supplier: 'Kanha Supplier', rate: 515,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Mar-19',
    duedate: '9-June-19', inwdate: '9-Jan-19', invdate: '9-May-19',
    grnno: 4, rating: 4, punctuality: 4
  },

  {
    orderno: 3, item: 'Fridge', supplier: 'Topiwala', rate: 845,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-April-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },
  {
    orderno: 4, item: 'Water', supplier: 'Ac Company', rate: 151,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },
  {
    orderno: 5, item: 'AC', supplier: 'Kanha Supplier', rate: 515,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },

  {
    orderno: 6, item: 'Fridge', supplier: 'Topiwala', rate: 845,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },
  {
    orderno: 7, item: 'Water', supplier: 'Ac Company', rate: 151,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },
  {
    orderno: 8, item: 'AC', supplier: 'Kanha Supplier', rate: 515,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },

  {
    orderno: 1, item: 'Fridge', supplier: 'Topiwala', rate: 845,
    ordqty: 2, amount: 3, inwqty: 5, unit: 544, orddate: '9-Feb-19',
    duedate: '9-Feb-19', inwdate: '9-Feb-19', invdate: '9-Feb-19',
    grnno: 4, rating: 4, punctuality: 34
  },

];

@Component({
  selector: 'app-purchase-history',
  templateUrl: './purchase-history.component.html',
  styleUrls: ['./purchase-history.component.scss']
})
export class PurchaseHistoryComponent implements OnInit {

  displayedColumns: string[] = ['orderno', 'item', 'supplier', 'rate', 'ordqty', 'amount', 'inwqty', 'unit', 'orddate', 'duedate', 'inwdate', 'invdate', 'grnno', 'rating', 'punctuality', 'status', 'notes', 'po'];

  subCategoryList: subCategory[] = [];
  categories: category[] = [];
  agencyData: any = [];
  jarvisData: any = [];
  copyItems: any = [];

  filter: any = 0;
  subCategoryCtrl = new FormControl();

  filteredsubCategoryList!: Observable<subCategory[]>;
  filteredCategory!: Observable<category[]>;
  dataSource = new MatTableDataSource<EmployeeList>(ELEMENT_DATA);

  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(private apiService: APIService, private router: Router) { }

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    //this.getAllUnits();
  }

  data: any = {
    ItemName: '',
    ItemID: 0,
    code: '',
    typeID: 1,
    categoryID: 0,
    subCategory: '',
    SubCategoryID: 0,
    category: '',
    Qty: '',
    Unit: 'no.s',
    purchaseCost: '',
    salePrice: '',
    stockRate: '',
    minStockQty: '',
    isAvailable: true,
    showOnline: true,
    isActive: true,
    importanceID: 1,
    HSN: '',
    HSNId: 0,
    brochureLink: '',
    fileLink: '',
    description: '',
    tag: '',
    leadTime: '',
    prcn: 0,
    storeName: '',
    storeID: '',
    IsMade: false,
    IsPurchased: false

  }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'Stock.xlsx');
  }

  selectCategory = () => {
    this.subCategoryList = [];
    if (this.data.category) {
      let tempCat = this.categories.filter((x: any) => x.cnm == this.data.category)
      if (tempCat.length > 0) {
        this.data.categoryID = tempCat[0].cid
        this.subCategoryList = tempCat[0].sub

        this.filteredsubCategoryList = this.subCategoryCtrl.valueChanges
          .pipe(
            startWith(''),
            map(employee => employee ? this._filterSubcategory(employee) : this.subCategoryList.slice())
          );


      } else {
        alert("Please configure category.")
        this.data.category = '';
        this.subCategoryList = [];
        this.data.subCategory = '';
      }
    }
  }

  private _filterSubcategory(value: string): subCategory[] {
    const filterValue = value.toLowerCase();
    return this.subCategoryList.filter(state => state.snm.toLowerCase().indexOf(filterValue) === 0);
  }

  typeFilter = (obj: any) => {
    var copyItems = this.copyItems
    var tempItem = [];
    this.filter = obj
    if (obj == 0) {
      tempItem = this.copyItems;
    }
    else if (obj == 1) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 1);
    }
    else if (obj == 2) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 2);
    }
    else if (obj == 3) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 3);
    }
    // else if (obj == 4) {
    //   tempItem = copyItems.filter((x: any) => x.TypeID == 4);
    // }
    // else if (obj == 5) {
    //   tempItem = copyItems.filter((x: any) => x.TypeID == 5);
    // }

    // this.Items = tempItem
    // this.dataSource.data = this.Items
    // //this.dataSource.filterPredicate = this.createFilter();
    // this.totalValue = 0;

    // for (let i = 0; i < this.Items.length; i++) {
    //   this.totalValue = this.totalValue + this.Items[i].ValStdCost
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }
}
